import React from 'react';
import { Link } from 'gatsby';
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiLinkedin,
  FiMapPin,
  FiPhoneCall,
  FiMail,
} from 'react-icons/fi';

import './footer.styles.scss';

type ContactLink = {
  icon: JSX.Element;
  href: string;
};

const currentYear = new Date().getFullYear();

const contactLinks: ContactLink[] = [
  {
    icon: <FiFacebook />,
    href: 'https://www.facebook.com/HopInTech/',
  },
  {
    icon: <FiTwitter />,
    href: 'https://twitter.com/hopintech/',
  },
  {
    icon: <FiInstagram />,
    href: 'https://www.instagram.com/hopintech/',
  },
  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/company/hop-in-tech/',
  },
];

const Footer = () => {
  return (
    <footer className="footer bg-color">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <div className="footer-widget">
              <Link to="/" className="logo">
                <img
                  src={require('../../../assets/photos/logo.png')}
                  alt="logo"
                />
              </Link>
              <p>
                Hop In is creating an ecosystem focused on improving the worker
                lifestyle by providing a marketplace of innovative solutions to
                the daily issues impacting the workforce.
              </p>
              <p>
                Hop In Microtransit Technologies Inc. complies fully with
                regulatory requirements under PIPEDA and FIPPA, and MFIPPA.
              </p>

              <ul className="social-link">
                {contactLinks.map(({ icon, href }, i) => (
                  <li key={i}>
                    <a
                      {...{ href }}
                      className="d-block"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {icon}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="footer-widget pl-5">
              <h3>Explore</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/offerings">Offerings</Link>
                </li>
                <li>
                  <Link to="/in-the-news">In the News</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="footer-widget">
              <h3>Resources</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/who-we-are">Who We Are</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-sm-6">
            <div className="footer-widget">
              <h3>Location</h3>

              <ul className="footer-contact-info">
                <li>
                  <FiMapPin size={20} />
                  <a
                    href="https://goo.gl/maps/bayTNvt1JU3geZuBA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    169 Enterprise Blvd Suite 300 Markham, ON L6G 0E7 <br />{' '}
                    Canada
                  </a>
                </li>
                <li>
                  <FiPhoneCall size={20} />{' '}
                  <a href="tel:+12898009711">+1 (289) 800 9711</a>
                </li>
                <li>
                  <FiMail size={20} />{' '}
                  <a href="mailto:info@hopintech.com">info@hopintech.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <p>
                Copyright @{currentYear} <strong>Hop In Technologies</strong>
              </p>
            </div>

            <div className="col-lg-6 col-md-6">
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-map">
        <img src={require('../../../assets/map/map.png')} alt="world map" />
      </div>
    </footer>
  );
};

export default Footer;
